import useSWR, { SWRConfiguration, SWRResponse } from 'swr';
import { AxiosError } from 'axios';
import { Shooting } from '../../../providers/api/dtos/shooting';
import { getAllShootingsByPropertyId, ShootingsByPropertyIdFilters } from '../../../providers/api/shooting/shootingProvider';
import { PaginationParams } from '../../../providers/pagination';

export const SHOOTINGS_BY_PROPERTY_ID_RID = '/property/:id/shooting';

export default function useAllShootingsByPropertyId(
  propertyId?: number | null | undefined,
  filters?: ShootingsByPropertyIdFilters,
  pagination?: PaginationParams,
  options?: SWRConfiguration<Shooting[] | undefined, AxiosError>,
): SWRResponse<Shooting[] | undefined, AxiosError> {
  const key = propertyId ? [SHOOTINGS_BY_PROPERTY_ID_RID, propertyId, filters, pagination] : null;

  return useSWR(key, () => getAllShootingsByPropertyId(propertyId!, filters, pagination), options);
}
